/** Represents the development environment. */
export const DEV_ENV = 'dev';
/** Represents the UAT (staging) environment. */
export const UAT_ENV = 'uat';
/** Represents the production environment. */
export const PROD_ENV = 'prod';
